import React, { useState, useEffect } from 'react';
import InvoiceDownloadButton from './InvoiceDownloadButton';
import './UserFormModal.css';

const BookingEditModal = ({ booking, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    discount_percent: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (booking) {
      setFormData({
        discount_percent: booking.discount_percent !== null && booking.discount_percent !== undefined
          ? String(booking.discount_percent)
          : ''
      });
    }
  }, [booking]);

  const validateForm = () => {
    const newErrors = {};
    const discount = parseFloat(formData.discount_percent);

    if (formData.discount_percent !== '' && formData.discount_percent !== null) {
      if (isNaN(discount)) {
        newErrors.discount_percent = 'Bitte geben Sie eine gültige Zahl ein';
      } else if (discount < 0) {
        newErrors.discount_percent = 'Rabatt darf nicht negativ sein';
      } else if (discount > 100) {
        newErrors.discount_percent = 'Rabatt darf nicht über 100% liegen';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const dataToSave = {
        discount_percent: formData.discount_percent === ''
          ? null
          : parseFloat(formData.discount_percent)
      };
      await onSave(booking.id, dataToSave);
    } catch (err) {
      setErrors({ submit: err.message || 'Fehler beim Speichern der Buchung' });
      setLoading(false);
    }
  };

  const formatCustomerName = () => {
    if (!booking || !booking.customer) return '';
    return `${booking.customer.first_name} ${booking.customer.last_name}`;
  };

  if (!booking) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Buchung bearbeiten</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Kunde</label>
            <div className="readonly-field">{formatCustomerName()}</div>
          </div>

          <div className="form-group">
            <label>Datum / Zeit</label>
            <div className="readonly-field">
              {booking.booking_date} {booking.time_slot}
            </div>
          </div>

          <div className="form-group">
            <label>Menge</label>
            <div className="readonly-field">
              {booking.quantity} {booking.unit}
            </div>
          </div>

          <div className="form-group">
            <label>Rechnung</label>
            {booking.invoice ? (
              <InvoiceDownloadButton
                invoice={booking.invoice}
                variant="full"
                className="save-button"
              />
            ) : (
              <div className="readonly-field">Noch keine Rechnung vorhanden</div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="discount_percent">Großkunden-Rabatt (%)</label>
            <input
              type="number"
              id="discount_percent"
              name="discount_percent"
              value={formData.discount_percent}
              onChange={handleChange}
              className={errors.discount_percent ? 'error' : ''}
              disabled={loading}
              min="0"
              max="100"
              step="0.5"
              placeholder="z.B. 10"
            />
            <small className="helper-text">
              Optional - wird bei Auftragserstellung automatisch angewendet
            </small>
            {errors.discount_percent && (
              <span className="error-message">{errors.discount_percent}</span>
            )}
          </div>

          {errors.submit && (
            <div className="submit-error">{errors.submit}</div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="save-button"
              disabled={loading}
            >
              {loading ? 'Speichern...' : 'Speichern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookingEditModal;
